import { Component, Input } from '@angular/core';
import { AnalystGauge } from '../analyst-gauge/analyst-gauge';
import { CountUp } from '../count-up/count-up';

// Gauge + rating/counts + potential-% — shared by V3AnalystsOverview's mobile card and
// V3AnalystsAnalysis's Rating Konsens block, which rendered identical markup independently.
@Component({
  selector: 'app-v3-analysts-stats-row',
  standalone: true,
  imports: [AnalystGauge, CountUp],
  templateUrl: './v3-analysts-stats-row.html',
  styleUrl: './v3-analysts-stats-row.scss',
})
export class V3AnalystsStatsRow {
  @Input({ required: true }) gaugeValue!: number;
  @Input({ required: true }) sellGaugeValue!: number;
  @Input({ required: true }) isPositive!: boolean;
  @Input({ required: true }) rating!: string;
  @Input() buyCount = 0;
  @Input() holdCount = 0;
  @Input() sellCount = 0;
  @Input() potential: number | null = null;
}
